export const entityProperties = `
    geoType
    fullUid
    name
    address
    city
    state
    zip
    membertype
    websiteurl
    phone
    email
    notes
    instruc
    description
    datelastchanged
    layerByLayerid {
        layername,
        type
    }
    entitycontactsByFullUid {
        nodes {
            objectid
            contactByPocid {
                pocid
                name
                cell
                land
                email
                pubconinfo
                instruc
                datelastchanged
            } 
        }
    }
`;
